import { useMutation, useQueryClient } from "@tanstack/react-query";

import { logger } from "#app/monitoring/Logger";
import { showErrorToast } from "#app/notifications";
import { quoteRequestLineQuery } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";
import {
  QuoteRequestLineDto,
  updateQuoteRequestLine,
} from "#modules/quoteRequestLines/infra/updateQuoteRequestLine.api";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";

type Props = {
  onSuccess?: (data: QuoteRequestLineDto) => void;
  quoteRequestId: string | undefined;
};

export const useUpdateQuoteRequestLine = ({ onSuccess, quoteRequestId }: Props) => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, ...rest } = useMutation({
    mutationFn: updateQuoteRequestLine,
    onSuccess: async (data) => {
      await queryClient.invalidateQueries(quoteRequestQuery(quoteRequestId));
      await queryClient.invalidateQueries(quoteRequestLineQuery({ id: data.id }));

      onSuccess?.(data);
    },
    onError: (error) => {
      logger.error(error);
      showErrorToast({
        title: "Une erreur est survenue",
        message: "Veuillez vérifier les données saisies et réessayer.",
      });
    },
  });

  return {
    updateQuoteRequestLine: mutate,
    updateQuoteRequestLineAsync: mutateAsync,
    ...rest,
  };
};
